import React from "react";
import ActionIcon from "./action-icon";
import { GripVertical } from "lucide-react";
import BusinessContext from "../../contexts/business-context";
import { useContext, useState, useRef, useEffect } from "react";
import DynamicIcon from "./dynamic-icon";
import { useTranslations } from "next-intl";
import { setCachedBusiness } from "../../lib/utils";
import SecondaryDropdownContainer from "./secondary-dropdown-container";
import DropdownOptionItem from "./dropdown-option-item";
import Spinner from "./spinner";

const BusinessMenuItem = ({ businessName, teamCount, id }) => {
  const { activeBusiness, renameBusiness } = useContext(BusinessContext);
  const [name, setName] = useState(businessName);
  const [isRenaming, setIsRenaming] = useState(false);
  const businessId = activeBusiness.uuid;
  const t = useTranslations('nav');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const inputRef = useRef(null);

  const handleClick = (e) => {
    e.preventDefault();
    setCachedBusiness(id);
    window.location.replace(`/${id}/home`);
  };

  useEffect(() => {
    if (isRenaming && inputRef.current) {
      const timeoutId = setTimeout(() => inputRef.current.focus(), 0);
      return () => clearTimeout(timeoutId);
    }
  }, [isRenaming]);

  const isActive = id === businessId;

  const handleBusinessRename= (newName) => {
    setName(newName)
    setIsSaving(true)
    const callback = () =>{ 
      setIsRenaming(false)
      setIsSaving(false)
    }

    renameBusiness(id, newName, callback)
  }

  return (
    <div onClick={handleClick} className={` group grid w-full items-center hover:custom-bg-grey-50 cursor-pointer content-center justify-between grid-flow-col gap-[16px] ${isActive ? 'custom-bg-grey-50' : ''} group p-1.5 px-3 rounded-lg`}>
      <div className="grid justify-start grid-flow-col gap-3 items-center min-w-0">
        <ActionIcon color='custom-text-grey-800'>
          <GripVertical size={22} color="currentColor" />
        </ActionIcon>
        <div className="grid grid-flow-col gap-3 items-center min-w-0">
          <div
            className={`w-[28px] h-[28px] grid justify-center items-center leading-[28px] text-center custom-text-grey-100 group-hover:custom-bg-white-50 ${isActive ? 'custom-bg-white-50' : ''} uppercase rounded-md font-bold text-[18px] flex-shrink-0`}
          >
            {name[0]}
          </div>
          <div className="grid grid-flow-col items-center min-w-0">
            <div className="grid min-w-0">
              {!isRenaming ? (
                <div className="flex items-center gap-[4px] min-w-0">
                  <span
                    className="poppins-bold text-[14px] custom-text-grey-800 leading-[15px] truncate min-w-0"
                  >
                    {name}
                  </span>
                  {/* {isActive && <div className="py-[2px] px-[5px] rounded-[8px] custom-bg-green-50 custom-text-green-900 text-[8px] flex-shrink-0">Active</div>} */}
                </div>
              ) : (
                <div onClick={(e) => e.stopPropagation()} className="flex items-center justify-between custom-text-grey-500 relative group lg:rounded-[4px] w-full custom-bg-white-50 text-[12px] h-[35px] px-[8px]">
                  <input
                    ref={inputRef}
                    type="text"
                    className="w-full outline-none poppins-medium bg-[transparent]"
                    defaultValue={name}
                    onBlur={(e) => handleBusinessRename(e.currentTarget.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleBusinessRename(e.currentTarget.value);
                      } else if (e.key === 'Escape') {
                        e.preventDefault();
                        setIsRenaming(false);
                      }
                    }}
                    onFocus={(e) => e.target.select()}
                  />
                  {isSaving ? (
                    <Spinner size={14} />
                  ) : (
                    <DynamicIcon
                      name="x"
                      color="cursor-pointer"
                      size={14}
                    onClick={() => setIsRenaming(false)}
                    />
                  )}
                </div>
              )}
              <span className="poppins-light custom-text-grey-800  text-[12px]">
                {t('freePlan')}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="relative">
        <DynamicIcon onClick={(e) => { e.stopPropagation(); setIsMenuOpen(!isMenuOpen); }} name='ellipsis' size={18} color={`custom-text-grey-800 `} />
        <SecondaryDropdownContainer isOpen={isMenuOpen} toggleDropdown={() => setIsMenuOpen(false)} additionalclasses='!min-w-[181px] !left-[-160px] !top-4'>
          <DropdownOptionItem onClick={(e) => { e.stopPropagation(); setIsRenaming(true); setIsMenuOpen(false); }} icon="pencil">Rename</DropdownOptionItem>
        </SecondaryDropdownContainer>
      </div> */}
      {isActive && <DynamicIcon name='check' size={18} color='custom-text-grey-800 group-hover:hidden' />}
    </div>
  );
};

export default BusinessMenuItem;
